import Ad from "@components/Advertisement/Ad";
import CandidatesLineUpBanner from "@pages/SingaporeGe/2025/components/CandidatesLineUpBanner";
import ComingUp from "@pages/SingaporeGe/2025/components/ComingUp";
import ConstituenciesToWatch from "@pages/SingaporeGe/2025/components/ConstituenciesToWatch/ConstituenciesToWatch";
import Highlights from "@pages/SingaporeGe/2025/components/Highlights";
import IframeEmbed from "@pages/SingaporeGe/2025/components/IframeEmbed";
import RelatedStoriesOverview from "@pages/SingaporeGe/2025/components/RelatedStoriesOverview";
import Videos from "@pages/SingaporeGe/2025/components/Videos";
import Whatsapp from "@pages/SingaporeGe/2025/components/Whatsapp";
import { SingaporeGEBasicProps } from "@pages/SingaporeGe/2025/utils/types";
import { ConfigTypeEnums } from "@typings/enums";
import { cn } from "@util/helpers";

export default function SingaporeGeComponentFactory({
  configData,
  highlights,
  relatedStories,
  comingUp,
  index,
  parentIndex,
  constituenciesData,
}: SingaporeGEBasicProps): React.ReactElement {
  if (typeof configData === "string" || !configData) return <></>;

  switch (configData.type) {
    case ConfigTypeEnums.TOPSTORIES:
      if (!highlights) return <></>;

      return (
        <Highlights
          articles={highlights}
          className={cn(
            "mb-8",
            {
              "border-t border-gray-850 pt-3": parentIndex !== 0 || index !== 0,
            },
            configData?.extraClass
          )}
          testId="ge-2025-top-stories-component"
          gaObject={configData.gaObject}
        />
      );

    case ConfigTypeEnums.RELATEDSTORIES:
      if (!relatedStories) return <></>;

      return (
        <RelatedStoriesOverview
          articles={relatedStories}
          className={cn(
            "mb-8",
            {
              "border-t border-gray-850 pt-3": parentIndex !== 0 || index !== 0,
            },
            configData?.extraClass
          )}
          testId="ge-2025-related-stories"
          gaObject={configData.gaObject}
        />
      );

    case ConfigTypeEnums.IFRAME:
      if (!configData) return <></>;

      return (
        <IframeEmbed
          className={cn(
            "mb-8",
            {
              "border-t border-gray-850 pt-3": index !== 0,
            },
            configData?.extraClass
          )}
          key={`iframe-${index}`}
          configData={configData}
          index={index || 0}
          gaObject={configData.gaObject}
        />
      );

    case ConfigTypeEnums.ADS:
      if (!configData.adType) return <></>;

      return (
        <Ad
          adType={configData.adType}
          className="flex items-center justify-center lg:sticky lg:top-20"
        />
      );

    case ConfigTypeEnums.COMINGUP:
      if (!comingUp) return <></>;

      return (
        <ComingUp
          article={comingUp}
          className={cn(
            "mb-8 border-t border-gray-850 pt-3 lg:border-0",
            {
              "lg:border-t": parentIndex !== 0 || index !== 0,
            },
            configData?.extraClass
          )}
          testId="ge-2025-coming-up-component"
          gaObject={configData.gaObject}
        />
      );

    case ConfigTypeEnums.VIDEOS:
      return (
        <Videos
          testId="ge-2025-videos-component"
          className={cn(
            "mb-8 border-t border-gray-850 pt-3",
            {
              "border-none": !comingUp,
            },
            configData?.extraClass
          )}
          gaObject={configData.gaObject}
        />
      );

    case ConfigTypeEnums.WHATSAPP:
      return (
        <Whatsapp
          className={cn(
            "border border-gray-850 p-2 lg:mb-6",
            configData?.extraClass
          )}
          testId="ge-2025-whatsapp-component"
          gaObject={configData.gaObject}
        />
      );

    case ConfigTypeEnums.BANNER:
      return <CandidatesLineUpBanner configData={configData} />;

    case ConfigTypeEnums.CONSTITUENCIES:
      if (constituenciesData?.length === 0) return <></>;

      return (
        <ConstituenciesToWatch
          configData={configData}
          constituenciesData={constituenciesData}
          className={cn(
            "mb-8",
            { "border-t border-gray-850 pt-4": index !== 0 },
            configData?.extraClass
          )}
        />
      );

    case ConfigTypeEnums.CREDITS:
      return (
        <div className={cn("mb-8", configData?.extraClass)}>
          <p className="font-poppins text-xs font-light text-gray-850">
            {configData.title}
          </p>
        </div>
      );

    default:
      return <></>;
  }
}
